import { Colors } from '@sigma-frontend-libs/commons'

import { components, icons } from '@/utils'

import buttonConfirm from '@/components/button/confirm'
import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'
import selectorOwner from '@/components/selector/owner'

function renderHeaderContent(h, options) {
  const { path, serviceName } = options

  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            icon: icons.settings,
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${serviceName}.subtitles.${path}`)
    ]
  )
}
function renderHeader(h, options, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderHeaderContent.call(this, h, options),
      h(arrow, { props: { expanded } })
    ]
  )
}

function renderField(h, options) {
  const { path, serviceName, defaults } = options

  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy,
        label: this.getTranslate(`${serviceName}.labels.${path}`),
        defaultValue: defaults[path],
        dense: true,
        multiple: true
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
function renderBody(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8 pa-2'
    },
    [
      h(
        buttonConfirm,
        {
          props: {
            value: this.proxy,
            loading: this.loading,
            disabled: this.disabled
          },
          on: {
            input: () => {
              this.submit()
            }
          }
        },
        [ renderField.call(this, h, options) ]
      )
    ]
  )
}

export default function(h, options) {
  return h(
    components['expansion-panel'],
    {
      props: {
        outline: true,
        rounded: true
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, options, expanded)
        },
        default: () => {
          return renderBody.call(this, h, options)
        }
      }
    }
  )
}
